import { useMemo } from 'react'
import { useShopify } from './useShopify'

const useFeatureFlags = () => {
  const { featureFlags } = useShopify()

  const getFlag = (flag: string): boolean => {
    return useMemo(
      () => featureFlags?.[flag] ?? false,
      [featureFlags, flag]
    ) as boolean
  }

  return { getFlag }
}

export { useFeatureFlags }
